<template>
    <v-container transparent>
        <v-layout>
            <v-card class="report-wrapper-s" width="100%" flat>
                <v-btn v-if="$store.state.user.level>1"
                        fixed
                        dark
                        fab
                        top
                        right
                        color="blue"
                        v-on:click="print"
                        style="top: 10%"
                >
                    <v-icon>print</v-icon>
                </v-btn>

                <span v-html="reportBody"></span>
            </v-card>
        </v-layout>
    </v-container>
</template>

<script>
    import scriptjs from 'scriptjs'



    export default {
        name: "MainReport",
        props: ['reportId','lang'],
        data: () => ({
            reportBody: "",
            reportData: {}
        }),
        watch: {
            reportId: function() {
                this.loadAndRender()
            },
            lang: function() {
                this.loadAndRender()
            }
        },
        methods: {
            print: () => {
                window.print()
            },
            downloadPdf() {
            },
            loadAndRender() {
                var that =this
                //console.log(this.reportId, this.lang)
                this.$http.post('/report', {reportId:this.reportId, lang:this.lang} ).then(function (response) {
                    //console.log(response)
                    if(response.data.user) {
                        //console.log(response.data.user)
                        that.$store.commit('user', {
                            user: response.data.user
                        })
                    }

                    if(response.status===401){
                        that.$store.commit('isAuthenticated', {
                            isAuthenticated: false
                        })
                        //router.push({path: '/user/login', query: {redirect: router.currentRoute.fullPath}})
                        //router.push(router.currentRoute.fullPath)
                        //console.log('!!!!!!!!!!!!!!', that.$router.currentRoute.fullPath)
                        const toUrl = that.$router.currentRoute.fullPath
                        //that.$router.go(-1)
                        //that.$router.push(toUrl)
                        that.$router.push({path: '/user/login', query: {redirect: toUrl}})
                    }

                    else if(response.status!==200) {
                        // eslint-disable-next-line
                        console.log(response.status)
                        that.$router.push('/')
                    }

                    else {
                        that.reportBody = response.data.renderResult
                        that.reportData = response.data.data

                        let config = that.reportData
                        for (let item in config.reportSchema.js.scripts) {
                            scriptjs(config.reportSchema.js.scripts[item])
                        }
                        window.reportData = {}
                        window.reportData[config.reportSchema.id] = config

                        // eslint-disable-next-line
                        console.log(config.reportSchema.wwwBaseDir + '/' + config.reportSchema.id + '/' + config.reportSchema.js.process)
                        console.log(config.reportSchema.wwwReportBaseDir + '/' + config.reportSchema.js.process)


                        scriptjs(config.reportSchema.wwwReportBaseDir + '/' + config.reportSchema.js.process, 'cli')
                        scriptjs.ready('cli', function () {
                            setTimeout(() => {
                                if(processData) processData(window.reportData[config.reportSchema.id])
                            }, 1000)
                        })
                    }

                });

            }
        },
        created: function () { this.loadAndRender()},
        mounted: function() {

        }

    }
</script>

<style lang="scss">
    .report-wrapper-s {
        background: transparent !important;
    }
</style>